import {useSessionStorage} from '../hooks/useSessionStorage'
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import LayoutEditor from '../layout/LayoutEditor'
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { Formik } from 'formik';


export default function ContactPage()
{
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [recaptchaResponse, setRecaptchaResponse] = useState("");
    const [messageSent, setMessageSent] = useState(false);

    const sleep = (delay) => {
        return new Promise(resolve => {
          setTimeout(resolve, delay)
        });
      }

    return <>
    <Container maxWidth="md" sx={{textAlign:'center'}}>
    <Typography
            variant="h4"
            sx={{my:3, color:'text.header'}}>
            We'd love to hear from you!
          </Typography>
    <p>Let us know your feedback, or any issues you may be having</p>
    <Formik
      initialValues={{ email: '', name: '', message:'', recaptcha :'' }}
      validate={values => {
          const errors = {};
          if (!values.name)
              errors.name = 'Please enter your Name';
          if (!values.email) {
          errors.email = 'Please enter your Email';
          } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
          ) {
          errors.email = 'Invalid email address';
          }

          if (!values.message)
              errors.message = 'Please enter a Message';

          return errors;
      }}
      onSubmit={(values, { setSubmitting, resetForm }) => {
          setSubmitting(true);

          // Check if the captcha was skipped or not
          if (!executeRecaptcha) {
              return
          }
          
          setMessageSent(false);

          executeRecaptcha('homepage').then((result)=>{
              fetch('https://contactformsubmit.azurewebsites.net/api/contact?', {
                  method: 'POST', // *GET, POST, PUT, DELETE, etc.
                  mode: 'cors', // no-cors, *cors, same-origin
                  cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                  credentials: 'same-origin', // include, *same-origin, omit
                  headers: {
                      'Content-Type': 'application/json'
                      // 'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  redirect: 'follow', // manual, *follow, error
                  referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                  body: JSON.stringify({'g-recaptcha-response':result,
                          profileID: 2,
                          name: values.name,
                          email: values.email,
                          message: values.message})
                  })
                  .then(res => res.json())
                  .then(data => {
                      setMessageSent(true);
                      resetForm();
                      setSubmitting(false);
                  })
                  .catch(error=>{
                      alert(error);
                      setSubmitting(false);
                  });
          });

      }}
      >
      {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue
          /* and other goodies */
      }) => (
  <form className="mb-7" onSubmit={handleSubmit} id="contactForm">
    
    <Box maxWidth="sm" sx={{mx:'auto', my:3}}>
    {messageSent && <Alert sx={{my:2}} severity="success">Thank you for your message. We will contact you back shortly.</Alert>}
    <Grid container spacing={1} sx={{'& .MuiGrid-root': {
        paddingTop: '5px',
      },}}>
      <Grid item xs={12}>
      <TextField fullWidth label="Name" size="small" variant="filled" name="name" value={values.name} onChange={handleChange}
            error={errors.name ? true : false}
            InputLabelProps={{ shrink: true }}
            />
      </Grid>
      <Grid item xs={12}>
      <TextField fullWidth label="Email" size="small" variant="filled" name="email" value={values.email} onChange={handleChange}
            error={errors.email ? true : false}
            InputLabelProps={{ shrink: true }}
            />
      </Grid>
      <Grid item xs={12}>
      <TextField fullWidth multiline rows={4} label="Message" size="small" name="message" variant="filled" value={values.message} onChange={handleChange}
            error={errors.message ? true : false}
            InputLabelProps={{ shrink: true }}
            />
      </Grid>
      <Grid item xs={12}>
      <Button type="submit" fullWidth disabled={isSubmitting} variant="contained" sx={{marginTop:'10px', marginBottom:'10px'}}>{isSubmitting ? 'Sending...' : 'Send'}</Button>
      </Grid>
  
    </Grid>
    </Box>
    </form>
      )}
      </Formik>
      
    </Container>
    </>
}